<template>
    <div class="lawsuit_1" v-loading="loading">
        <div class="fomr_box">
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    案件名称
                </div>
                <div class="form_input">
                    <div class="inputs">
                        <el-input v-model="form.title" placeholder="请输入案件名称"></el-input>
                    </div>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    案件类型
                </div>
                <div class="form_input">
                    <div class="checks">
                        <el-select v-model="form.case_type" placeholder="请选择案件类型">
                            <el-option v-for="(item,index) in case_type_list" :key="index" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    申请人类型
                </div>
                <div class="form_input">
                    <div class="checks">
                        <el-select v-model="form.custom_type" placeholder="请选择申请人类型">
                            <el-option v-for="(item,index) in custom_type_list" :key="index" :label="item.title"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    联系人姓名
                </div>
                <div class="form_input">
                    <div class="inputs">
                        <el-input v-model="form.custom_name" placeholder="请输入联系人"></el-input>
                    </div>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    手机号
                </div>
                <div class="form_input">
                    <div class="inputs">
                        <el-input v-model="form.custom_phone" placeholder="请输入手机号"></el-input>
                    </div>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    所在地区
                </div>
                <div class="form_input">
                    <div class="checks">
                        <el-cascader placeholder="请选择城市名称" clearable v-model="area_ac" :options="area_list"  :props="props" @change="handleChange"></el-cascader>
                    </div>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    电子邮箱
                </div>
                <div class="form_input">
                    <div class="checks">
                        <div class="inputs">
                        <el-input v-model="form.email" placeholder="请输入电子邮箱（若没有则填无）"></el-input>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btns_flex">
            <div class="btns1" @click="handle_end">下一步</div>
            <div class="btns2" @click="handle_qx">取消</div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'




export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            form:{
                title:'',//案件名称
                easy:'',//简单咨询 1 ，详情 2
                proceed:'',//诉讼服务1，非 2
                case_type:'',//案件类型 （加单、诉讼）
                custom_type:'',//申请人类型 （加单、诉讼）1自然人 2法人 3其他组织
                custom_name:'',//联系人姓名
                custom_phone:'',//联系人电话
                pro_type:'',//产品类型 （加单、非诉讼必填）
                province:'',//委托人所在省
                city:'',//市
                area:'',//区
                email:'',//邮箱
                order_type:'',//1法律-在线咨询 2法律-预约律师 3立即咨询
                lawyer_id:'',//律师id
                pro_id:'',//服务id
            },
            case_type_list:[],//案件类型列表
            custom_type_list:[
                {
                    title:'自然人',
                    value:1,
                },
                {
                    title:'法人',
                    value:2,
                },
                {
                    title:'其它组织',
                    value:3,
                },
                
            ],//申请人类型
            //地区
            area_list: [],
            area_ac:[],
            props:{
                label:'name',
                value:'id',
                children:'children',
            },
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_case_type_list()
        this.get_area()
        this.form.easy=this.$route.query.title_num
        this.form.proceed=this.$route.query.type2_ac
        this.form.order_type=this.$route.query.order_type
        this.form.lawyer_id=this.$route.query.lawyer_id
        
    },
    methods: {
          //获取地区列表
          get_area(){
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.area_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        //获取案件类型
        get_case_type_list(){
            this.loading=true
            this.$api("tags", {
                type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('案件类型',res)
                if (res.code == 1) {
                    this.case_type_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        //地区选择触发
        handleChange(e){
            console.log('选择',e)
        },
     
        handle_end(){
            if(!this.form.title){
                alertErr('请输入案件名称')
                return
            }
            
            if(!this.form.case_type){
                alertErr('请选择案件类型')
                return
            }
            if(!this.form.custom_type){
                alertErr('请选择申请人类型')
                return
            }
            if(!this.form.custom_name){
                alertErr('请输入联系人姓名')
                return
            }
            if(!this.form.custom_phone){
                alertErr('请输入手机号')
                return
            }
            let reg = /^((11[0-9])|(12[0-9])|(13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
            if (!reg.test(this.form.custom_phone)) {
                alertErr('请输入正确的手机号')
                return 
            }

            if(this.area_ac.length==0){
                alertErr('请选择所在地区')
                return
            }
            this.form.province=this.area_ac[0]
            this.form.city=this.area_ac[1]
            this.form.area=this.area_ac[2]

            if(!this.form.email){
                alertErr('请输入电子邮箱（若没有则填无）')
                return
            }
            console.log('form',this.form)
            this.loading=true
            this.$api("appointStep1", {
               ...this.form,
               pro_id:this.$route.query.pro_id,
               carry_order_id:this.$route.query.order_id,
               order_id:this.$route.query.jf_order_id

			}, "post").then((res) => {
                this.loading = false
                console.log('创建订单',res)
                if (res.code == 1) {
                    this.$emit('handle_end1',res.data)
                } else {
                    alertErr(res.msg)
                }
            });


           
        },
        handle_qx(){
            this.$router.back()
        },


    },

}
</script>
<style scoped lang="less">
.lawsuit_1 {
    padding: 0 40px;
    padding-top: 80px;

    .fomr_box {
        padding-bottom: 40px;
        border-bottom: 2px dashed  #B9B9B9;
        .form_flex {
            display: flex;
            align-items: center;
            margin-bottom: 24px;
            .form_title {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: 200px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                padding-right: 24px;

                span {
                    color: #FD4C5C;
                    padding-right: 5px;
                }
            }

            .form_input {
                width: 400px;

                .checks {
                    width: 400px;

                    /deep/.el-select {
                        width: 400px;

                    }
                    /deep/.el-cascader{
                        width: 400px;
                    }

                }
                .inputs{

                }
            }
        }
    }
    .btns_flex{
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 46px;
        .btns1{
            width: 134px;
            height: 40px;
            background: #377CFD;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #377CFD;
            text-align: center;
            line-height: 40px;
            text-align: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 14px;
            color: #FFFFFF;
            cursor: pointer;

        }
        .btns2{
            width: 134px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #377CFD;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 14px;
            color: #377CFD;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
            margin-left: 16px;
        }
    }
}
</style>